<section
  class="flex min-h-screen items-center justify-center bg-slate-900 px-4"
>
  <div
    class="w-full max-w-md rounded-2xl border border-slate-700 bg-slate-800 p-6 text-slate-100 shadow-2xl"
  >
    <div class="mb-6 text-center">
      <img
        src="logo2.png"
        alt="Logo"
        class="mx-auto mb-2 h-15 w-15 rounded-full"
      />
      <h3 class="text-2xl font-bold">Bienvenido</h3>
      <p class="text-sm text-slate-400">
        @if (paso === 'credenciales') {
          Accede al panel de administración
        } @else {
          Verificación en dos pasos
        }
      </p>
    </div>

    <!-- Paso 1: Credenciales -->
    @if (paso === 'credenciales') {
      <form (ngSubmit)="iniciarSesion()" class="space-y-4">
        <div class="text-center text-sm">
          <span class="text-amber-300">{{ warningText }}</span>
          <span class="text-emerald-300">{{ successText }}</span>
        </div>

        <div>
          <label for="email" class="mb-1 block text-sm font-medium">Correo electrónico</label>
          <div class="flex items-center rounded-lg border border-slate-600 bg-slate-900 px-3">
            <i class="bi bi-envelope text-slate-400"></i>
            <input
              [(ngModel)]="email"
              type="email"
              class="w-full bg-transparent px-3 py-2 text-sm outline-none"
              id="email"
              name="email"
              placeholder="ejemplo@correo.com"
              required
              [disabled]="loading"
            />
          </div>
        </div>

        <div>
          <label for="contra" class="mb-1 block text-sm font-medium">Contraseña</label>
          <div class="flex items-center rounded-lg border border-slate-600 bg-slate-900 px-3">
            <i class="bi bi-lock text-slate-400"></i>
            <input
              [(ngModel)]="contra"
              type="password"
              class="w-full bg-transparent px-3 py-2 text-sm outline-none"
              id="contra"
              name="contra"
              required
              [disabled]="loading"
            />
          </div>
        </div>

        <button
          type="submit"
          class="flex w-full items-center justify-center gap-2 rounded-lg bg-sky-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-sky-500 disabled:cursor-not-allowed disabled:opacity-70"
          [disabled]="loading"
        >
          @if (loading) {
            <span class="h-4 w-4 animate-spin rounded-full border-2 border-white/40 border-t-white"></span>
            Verificando...
          } @else {
            Acceder
          }
        </button>
      </form>
    }

    <!-- Paso 2: Código OTP -->
    @if (paso === 'otp') {
      <form (ngSubmit)="verificarOtp()" class="space-y-4">
        <div class="text-center text-sm">
          <span class="text-amber-300">{{ warningText }}</span>
          <span class="text-emerald-300">{{ successText }}</span>
        </div>

        <div class="rounded-lg border border-slate-600 bg-slate-900/50 p-3 text-center">
          <p class="text-xs text-slate-400 mb-1">Código enviado a</p>
          <p class="text-sm font-medium text-sky-400">{{ email }}</p>
        </div>

        <div>
          <label for="otp" class="mb-1 block text-sm font-medium">Código de verificación</label>
          <div class="flex items-center rounded-lg border border-slate-600 bg-slate-900 px-3">
            <i class="bi bi-shield-check text-slate-400"></i>
            <input
              [(ngModel)]="otp"
              type="text"
              inputmode="numeric"
              maxlength="6"
              class="w-full bg-transparent px-3 py-2 text-center text-lg tracking-[0.5em] outline-none"
              id="otp"
              name="otp"
              placeholder="000000"
              required
              autocomplete="one-time-code"
              [disabled]="loading"
            />
          </div>
        </div>

        <button
          type="submit"
          class="flex w-full items-center justify-center gap-2 rounded-lg bg-emerald-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-emerald-500 disabled:cursor-not-allowed disabled:opacity-70"
          [disabled]="loading || otp.length !== 6"
        >
          @if (loading) {
            <span class="h-4 w-4 animate-spin rounded-full border-2 border-white/40 border-t-white"></span>
            Verificando...
          } @else {
            Verificar código
          }
        </button>

        <button
          type="button"
          class="flex w-full items-center justify-center gap-2 rounded-lg border border-slate-600 px-4 py-2 text-sm text-slate-400 transition hover:bg-slate-700 hover:text-slate-200"
          (click)="volverACredenciales()"
          [disabled]="loading"
        >
          <i class="bi bi-arrow-left"></i>
          Volver
        </button>
      </form>
    }

    @if (paso === 'credenciales') {
      <div class="mt-3 text-center">
        <a href="#" class="text-xs text-slate-400 hover:text-slate-200"
          >¿Olvidaste tu contraseña?</a
        >
      </div>
    }
  </div>
</section>
